export const CRITEO_ADS_BETA_FEATURE = 'CRITEO_ADS';

export const CITRUS_ADS_BETA_FEATURE = 'CITRUS_ADS';
export const CITRUS_AD_PROVIDER = 'citrusAd';
export const CITRUS_FOP_ATTRIBUTE = 'sponsored_item_click_beacon';
